import React from 'react'

const Hope = () => {
  return (
    <div className='w-full h-[50%] my-16 mx-auto'>
        <div className='text-[rgb(142,36,170)] max-w-[1000px] mx-auto'>
            <h1 className='text-[#4c1c5c] md:text-5xl sm:text-4xl text-3xl capitalize text-center my-8 font-bold'>There is hope</h1>
            <p className='text-center md:text-4xl sm:text-3xl text-2xl'>Patients need someone to hope and support them emotionally. No one
            fights cancer alone. If you want to fight this fight, I will fight
            with you!!!</p>
            <h3 className='text-center my-4 sm:text-2xl text-xl'>Source - <strong>Betty</strong></h3>
        </div>
      
    </div>
  )
}

export default Hope
